import React, { FunctionComponent } from 'react';
import ClientOverviewInvoicesEmpty from './ClientOverviewInvoicesEmpty';
import styles from './ClientOverviewInvoicesPanel.module.scss';
import { ClientOverviewInvoice } from './ClientOverviewInvoicesTable';

interface ClientOverviewInvoicesPanelProps {
    invoices: ClientOverviewInvoice[];
}

export const ClientOverviewInvoicesPanel: FunctionComponent<ClientOverviewInvoicesPanelProps> = props => {
    return (
        <div className={styles.panel}>
            <div className={styles.panelHeader}>
                <h3 className={styles.panelTitle}>Invoices</h3>
                <span
                    className={styles.headerActionPlaceholder}
                    aria-hidden="true"
                />
            </div>
            <div className={styles.scrollPanel}>
                <div className={styles.scrollPanelInner}>
                    {props.invoices.length === 0 ? (
                        <ClientOverviewInvoicesEmpty />
                    ) : (
                        props.invoices.map(invoice => (
                            <div
                                key={invoice.id}
                                className={styles.invoiceRow}
                            >
                                <div>
                                    <p className={styles.invoiceData}>{invoice.date}</p>
                                    <p className={styles.invoiceData}>{invoice.number}</p>
                                </div>
                                <div className={styles.invoiceAmounts}>
                                    <span>{invoice.total}</span>
                                </div>
                            </div>
                        ))
                    )}
                </div>
            </div>
        </div>
    );
};

export default ClientOverviewInvoicesPanel;
